import { Col, Drawer, Row } from "melco-ui";
import { useTranslation } from "react-i18next";
import { MelcoModelsGenericList1MelcoModelsUserProductListItem } from "melco-shared-logic";
import { DesignTokens } from "melco-ui";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";
import { Table } from "melco-ui";
import { useGetAllProductsList } from "../../../hooks/product/useGetAllProductsList";
import { ListThumbnail } from "./ListThumbnail";
import { useEffect, useState } from "react";
import { UserProductAssignActionButton } from "../UserProductAssignActionButton";
import { UserProductUnassignActionButton } from "../UserProductUnassignActionButton";
import { useAssignUnassignProducts } from "../../../hooks/users/useAssignUnassignProducts";
import { QueryObserverResult } from "react-query";
import { UserProductStartTrialActionButton } from "../UserProductStartTrialActionButton";
import styled from "styled-components";
import { differenceInDays } from "date-fns";

type UserProductsDrawerProps = {
  referencesProductDrawer: DrawerType;
  refetch?: () => Promise<
    QueryObserverResult<
      MelcoModelsGenericList1MelcoModelsUserProductListItem,
      unknown
    >
  >;
  onSelectProductByUser?: (v: string) => void;
  onCloseProductsDrawer: () => void;
};

const { spacings } = DesignTokens;

const Wrapper = styled.div`
  margin-left: 5px;
  margin-right: 5px;
`;

export const UserProductsDrawer: React.FC<UserProductsDrawerProps> = ({
  refetch,
  onCloseProductsDrawer,
  referencesProductDrawer,
}) => {
  const { t } = useTranslation();

  const [userProductsArray, setuserProductsArray] = useState<string[]>([]);

  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,
    pagination
  } = useGetAllProductsList();

  //user products
  // const userProducts = useUserProductsData(userId);
  const { products } = useAssignUnassignProducts();
  const { isDrawerOpen } = referencesProductDrawer;
  const userProductList = products ?? undefined;

  useEffect(() => {
    const arr: any[] = [];
    userProductList?.map((p) => {
      arr.push(p?.code ?? undefined);
    });
    setuserProductsArray(arr);
  }, [userProductList]);

  const callBackUnassignFn = async () => {
    if (refetch) {
      refetch();
    }
  };

  const callBackAssignFn = async () => {
    if (refetch) {
      refetch();
    }
  };

  const callBackStartTrialFn = async () => {
    if (refetch) {
      refetch();
    }
  };

  const columns = [
    {
      title: "",
      key: "svg_icon_url",
      dataIndex: "svg_icon_url",
      sorter: false,
      render: (rowObj: any) => <ListThumbnail thumbnailSrc={rowObj} />,
      width: spacings.xlarge + 2 * spacings.middle, // 2 * spacings.middle to compensate for table padding
      //height: spacings.xlarge + 2 * spacings.middle, // 2 * spacings.middle to compensate for table padding
    },
    {
      title: t("users.products.table.column.product"),
      key: "name",
      dataIndex: "name",
      sorter: true,
      width: "33%",
    },
    {
      title: t("users.products.table.column.description"),
      key: "code",

      render: (row: any) => {
        let doesUserProductsArrayIncludesThisProduct =
          userProductsArray.includes(row.code!);
        let userProductObject = userProductList.filter(
          (p) => p.code == row.code
        );
        let expires_on = userProductObject?.[0]?.expires_on ?? null;
        // console.log(" nnnn ",expires_on)
        let daysLeft = expires_on
          ? differenceInDays(new Date(expires_on), new Date())
          : 0;

        console.log(daysLeft);
        /**
        
            2. account/products ->expires on is less than current DateTime then Assign + 0 Days left 

            3. account/products ->expires on is greater than current DateTime then Assign + Calculate the days and display

            4. Show description as 'Permanent' if expires_on is null 

            6. expires_on will be returned only if the is_trial_available is true 
              and if the user started the trial. If the product is available in the list  
              with is_trial_available but does not have expires_on then it indicates 
              the product is already assigned to the user.
         */
        return (
          <div>
            <Row>
              <Col>
                {doesUserProductsArrayIncludesThisProduct &&
                  userProductObject?.[0]?.expires_on && (
                    <div>
                      {daysLeft > 0 ? daysLeft + " Days Left" : "0 days left"}
                    </div>
                  )}
              </Col>

              <Col>
                {doesUserProductsArrayIncludesThisProduct &&
                  !userProductObject?.[0]?.expires_on && <div> Permanent </div>}
              </Col>
            </Row>
          </div>
        );
      },
    },
    {
      title: t("users.products.table.column.action"),
      key: "code",
      width: "40%",

      render: (row: any) => {
        let doesUserProductsArrayIncludesThisProduct =
          userProductsArray.includes(row.code!);
        let userProductObject = userProductList.filter(
          (p) => p.code == row.code
        );
        let expires_on = userProductObject?.[0]?.expires_on ?? null;
        let daysLeft = expires_on
          ? differenceInDays(new Date(expires_on), new Date())
          : 0;

        console.log(daysLeft);
        /**
         * 1. If the product is missing in account/products but exists in /products + is_trial_available=1 then display Start Trial+ Assign

            2. account/products ->expires on is less than current DateTime then Assign + 0 Days left 

            3. account/products ->expires on is greater than current DateTime then Assign + Calculate the days and display

            4. Show description as 'Permanent' if expires_on is null 

            5. other use cases are still applicable i.e. is_removeable 
            6. expires_on will be returned only if the is_trial_available is true 
              and if the user started the trial. If the product is available in the list  
              with is_trial_available but does not have expires_on then it indicates 
              the product is already assigned to the user.
         */
        return (
          <div>
            <Row>
              {/* <Col>{(!doesUserProductsArrayIncludesThisProduct || (doesUserProductsArrayIncludesThisProduct && userProductObject?.[0]?.expires_on)) && <Wrapper>YYY<UserProductAssignActionButton productCodeToAssign={row.code} callBackFn={() => callBackAssignFn()} buttonName={"topAssign"} /> </Wrapper>}</Col> */}
              <Col>
                {" "}
                {!doesUserProductsArrayIncludesThisProduct &&
                  row.is_trial_available && (
                    <Wrapper>
                      <UserProductStartTrialActionButton
                        buttonName="StartTrial"
                        productCodeToStartTrial={row.code}
                        callBackFn={() => callBackStartTrialFn()}
                      />
                    </Wrapper>
                  )}
              </Col>
              <Col>
                {doesUserProductsArrayIncludesThisProduct &&
                  row.is_removable &&
                  !userProductObject?.[0]?.expires_on && (
                    <Wrapper>
                      {" "}
                      <UserProductUnassignActionButton
                        callBackFn={() => callBackUnassignFn()}
                        productCodeToUnassign={row.code}
                      />
                    </Wrapper>
                  )}
              </Col>
              <Col>
                {(!doesUserProductsArrayIncludesThisProduct ||
                  (doesUserProductsArrayIncludesThisProduct &&
                    userProductObject?.[0]?.expires_on)) && (
                    <Wrapper>
                      {" "}
                      <UserProductAssignActionButton
                        productCodeToAssign={row.code}
                        callBackFn={() => callBackAssignFn()}
                        buttonName={"Assign"}
                      />
                    </Wrapper>
                  )}
              </Col>
            </Row>
          </div>
        );
      },
    },
  ];

  return (
    <Drawer
      title={t("users.products.drawer_title")}
      placement="right"
      width={800}
      closable={true}
      onClose={onCloseProductsDrawer}
      open={isDrawerOpen}
      bodyStyle={{ padding: 10 }}
      destroyOnClose={true}
      forceRender={true}
    >
      <Table
        showSorterTooltip={false}
        loading={isPreviousData ? isFetching : isLoading}
        dataSource={data}
        columns={columns}
        onChange={onTableConfigChange}
        rowKey="code"
        noDataMessage={t("users.products.table.no_data_message")}
        errorComponent={errorComponent}
        pagination={pagination}
      />

    </Drawer>
  );
};
